
import Vue from "vue";
import { http } from '../../http';
import filter from 'lodash/filter';
import map from 'lodash/map';


export default {
    state: {
        treatments: [],
        loaded: false,
        loading: false
    },

    getters: {
        all: (state) => {
            return map(state.treatments, (treatment_group) => {
                return filter(treatment_group, (treament) => {
                    return !treament.deleted_at;
                });
            });
        },
        allWithTrashed: (state) => {
            return state.treatments;
        },
    },

    mutations: {
        setTreatments(state, data) {
            state.treatments = data.data;
        },
        setTreatmentsLoading(state, isLoading = true) {
            state.loading = isLoading;
        },
        setTreatmentsLoaded(state, isLoading = true) {
            state.loaded = isLoading;
        },
    },

    actions: {

        loadData(context, query_params) {
            context.dispatch('loadTreatments', query_params);
        },

        loadTreatments({ state, commit }) {

            if (state.loaded || state.loading) {
                return;
            }

            commit('setTreatmentsLoading', true);

            return new Promise((resolve, reject) => {
                http.get('/app/settings/apps/sygeforsikringdanmark/products/grouped')
                    .then(data => {
                        commit('setTreatments', data);
                        commit('setTreatmentsLoading', false);
                        commit('setTreatmentsLoaded', true);
                        resolve(data);  // Let the calling function know that http is done. You may send some data back
                    }, error => {
                        // http failed, let the calling function know that action did not work out
                        commit('setTreatmentsLoaded', false);
                        reject(error);
                    });
            });
        },
    }
}